import React from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse, NavItem, NavLink } from "shards-react";
import authStore, { types as authTypes, actions as authActions } from "../../../core/auth.store";

export default function UserActions() {
  const [visible, setVisible] = React.useState(false);
  const [user, setUser] = React.useState({});

  React.useEffect(() => {
    const appStoreToState = () => {
      const u = authStore.getState().auth_reducer.user;
      setUser(u && u.name ? u : {});
    };
    appStoreToState();
    const unsub = authStore.subscribe(appStoreToState);
    return () => unsub();
  }, []);

  const toggleUserActions = () => setVisible((v) => !v);

  const userLogout = () => {
    authStore.dispatch({ type: authTypes.INIT_AUTH_STATE });
    authStore.dispatch({ type: authTypes.INIT_SSO_STATE });
    authActions.removeAuthStorage();
    const subdomain = process.env.REACT_APP_SUB_DOMAIN || "";
    window.location.href = subdomain + "/login";
  };

  return (
    <NavItem tag={Dropdown} caret toggle={toggleUserActions} drop="left" open={visible}>
      <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
        <span className="d-none d-md-inline-block">{user && user.name}</span>
      </DropdownToggle>
      <Collapse tag={DropdownMenu} small open={visible} className="dropdown-menu-left">
        <DropdownItem divider />
        <DropdownItem tag="button" type="button" onClick={userLogout} className="text-danger">
          <i className="material-icons text-danger">&#xE879;</i> Logout
        </DropdownItem>
      </Collapse>
    </NavItem>
  );
}
